/** Minimum KROWN balance (numeric) to qualify for managed validator path. */
// TODO: Change this on PRODUCTION to 100_000_000
export const MANAGED_VALIDATOR_THRESHOLD = 100;

// Production: 100_000_000
// export const MANAGED_VALIDATOR_THRESHOLD = 100_000_000;

/** Minimum KROWN balance (numeric) to qualify for shared node path. */
// TODO: Change this on PRODUCTION to 100_000
export const SHARED_NODE_THRESHOLD = 1;


// Production: 100_000
// export const SHARED_NODE_THRESHOLD = 100_000;
